/** @jsx $jsx */
import { $jsx } from 'framework7';
import { usadosFunciones } from "../js/usadosFunciones";

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on;
  var usados = new usadosFunciones();
  var userID = localStorage.getItem('idUser');
  $on('pageInit', function (event, page) {
    var vehiculoID = page.route.query.id;
    var marcaID = page.route.query.marca;
    var modeloID = page.route.query.modelo;
    var versionID = page.route.query.version;
    $('#id_usuario').val(userID);

    if (vehiculoID) {
      usados.listarVehiculos($f7, vehiculoID);
      $('#title-page').empty();
      $('#title-page').html('EDITAR VEHICULO'); // Cargo desplegables

      usados.getMarcas($f7, marcaID);
      usados.getModelos($f7, marcaID, modeloID);
      usados.getVersiones($f7, modeloID, versionID); // Cargo el resto de la informacion de la unidad cargada

      usados.listarVehiculo($f7, vehiculoID);
      $('#id_vehiculo').val(vehiculoID); // Agrego el link correspondiente al link de imagenes

      $('#btn-imagen-color').css('color', '#00b33c');
      $('#btn-href-url').attr("href", '/usadosimagenes/?id_vehiculo=' + vehiculoID);
    } else {
      usados.getMarcas($f7, 0);
      $('#id_vehiculo').val(0);
    }

    $('#get-marcas').on('change', function () {
      var marcaID = $(this).val();
      usados.getModelos($f7, marcaID, 0);
    });
    $('#get-modelos').on('change', function () {
      var modeloID = $(this).val();
      usados.getVersiones($f7, modeloID, 0);
    });
    $('#saveVehiculo').on('click', function () {
      usados.saveVehiculos($f7, 'form-vehiculos');
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="abm">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Volver</span>
          </a>
        </div>
        <div class="title" id="title-page">ALTA VEHICULO</div>
      </div>
    </div>
    <div class="toolbar tabbar tabbar-labels toolbar-bottom">
      <div class="toolbar-inner">
        <a href="#tab-1" class="tab-link" id="saveVehiculo">
          <i class="icon f7-icons if-not-md" style="color: darkslateblue;">floppy_disk</i>
          <i class="icon material-icons md-only">floppy_disk</i>
          <span class="tabbar-label">Guardar</span>
        </a>
        <!-- <a href="/checklist/" class="link">
          <i class="icon f7-icons if-not-md">checkmark_alt_circle_fill</i>
          <i class="icon material-icons md-only">checkmark_alt_circle_fill</i>
          <span class="tabbar-label">Check List</span>
        </a> -->
        <a href="" class="link" id="btn-href-url">
          <i class="icon f7-icons if-not-md" id="btn-imagen-color">cloud_upload_fill</i>
          <i class="icon material-icons md-only">file_upload</i>
          <span class="tabbar-label">Imagenes</span>
        </a>
      </div>
    </div>
    <div class="page-content">
      <form id="form-vehiculos">
        <input type="hidden" id="id_vehiculo" name="id_vehiculo" />
        <input type="hidden" id="id_usuario" name="id_usuario" />
        <div class="block">
          <p class="row text-align-right">
            <a class="" href="#"></a>
            <a class="" href="#"></a>
            <a class="button button-fill button-small color-pink back" href="#">Cancelar</a>
          </p>
          <p class="alert">Todos los campos son obligatorios</p>
          <div class="list">
            <ul>
              <li>
                <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar marca">
                  <select name="marca" id="get-marcas">        
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-marcas-title">Marca</div>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar modelo">
                  <select name="modelo" id="get-modelos">
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-modelos-title">Modelo</div>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar version">
                  <select name="version" id="get-versiones">
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-versiones-title">Version</div>
                    </div>
                  </div>
                </a>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="text" id="patente" name="patente" placeholder="PATENTE" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="number" id="anio" name="anio" placeholder="AÑO" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="number" id="kilometros" name="kilometros" placeholder="KILOMETROS" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="text" id="color" name="color" placeholder="COLOR" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <textarea placeholder="Comentarios" id="comentario" name="comentario" ></textarea>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </div>
  `
    }
    ;
}

framework7Component.id = 'bae1cbd6bc';
export default framework7Component;